import React from "react";
import Context from "../../../../../Context";
import InputForm from "../../../../Misc/InputForm";
import Blocker from "../../../../Misc/Blocker";

export default class WorkflowProfile extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      notFound: false,
      item: {},
      itemsOrdered: {},
      essence: {},
    };
  }

  getChildren = (items, seekId, level) => {
    let children = {};

    Object.entries(items).forEach(([id, item]) => {
      if (String(item.parent) === seekId) {
        children[id] = { ...item, level };
        children = Object.assign(
          children,
          this.getChildren(items, id, level + 1)
        );
      }
    });

    return children;
  };

  componentDidMount() {
    this.load();
  }

  save = async (data) => {
    if (this.state.item["id"]) {
      data.id = this.state.item["id"];
      this.setState({ pending: true });
      let result = await this.context.api.q("/workflow/class/set", data);
      if (result !== false) {
        this.context.toast("Класс сохранен", "success");
        this.props.onFinish(result);
        this.setState({ pending: false });
      } else {
        this.context.toast("Не удалось сохранить класс", "error");
        this.setState({ pending: false });
      }
    } else {
      this.context.toast(
        "Не удалось сохранить класс: не удалось определить индентификатор",
        "error"
      );
    }
  };

  load = async () => {
    this.setState({ pending: true });
    let item = {};
    let itemsOrdered = {};
    let essence = {};

    let notFound = false;
    let result = await this.context.api.q("/workflow/class/get", {
      id: this.props.activeItem,
    });
    if (result !== false) {
      item = result;

      essence = await this.context.api.qo("/workflow/entity/list", {
        orderby: ["name ASC"],
      });
      itemsOrdered = await this.context.api.qoo("/workflow/class/list");
    } else {
      notFound = true;
    }
    this.setState({ pending: false, notFound, item, itemsOrdered, essence });
  };

  render() {
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            <InputForm
              fields={{
                parent: {
                  title: "Родитель",
                  type: "select",
                  values: this.state.itemsOrdered,
                  valuesNameKey: "label",
                  validate: true,
                  error: false,
                  default: "",
                  col: "12",
                },
                entity: {
                  title: "Сущность",
                  type: "select",
                  values: this.state.essence,
                  valuesNameKey: "name",
                  validate: true,
                  error: false,
                  default: "",
                  col: "12",
                },
                label: {
                  title: "Наименование",
                  type: "text",
                  validate: true,
                  error: false,
                  default: "",
                  col: "12",
                },
                code: {
                  title: "Код",
                  type: "text",
                  validate: true,
                  error: false,
                  default: "",
                  col: "12",
                },

                abstract: {
                  title: "Абстрактный",
                  type: "check",
                  validate: false,
                  error: false,
                  default: false,
                },
              }}
              data={this.state.item}
              key={this.state.item["id"]}
              onSubmit={this.save}
            />
          </Blocker>
        </div>
      </>
    );
  }
}
